'use client';

import { twMerge } from 'tailwind-merge';
import { useMemo } from 'react';

export interface ProgressBarProps {
  maxValue: number;
  filledValue: number;
  className?: string;
  fillColor?: string;
}

export const ProgressBar = ({ maxValue, filledValue, className, fillColor = 'bg-primary' }: ProgressBarProps) => {
  const filledPercentage = useMemo(() => {
    if (!maxValue) return 0;
    return filledValue > maxValue ? 100 : (filledValue / maxValue) * 100;
  }, [maxValue, filledValue]);

  return (
    <div className={twMerge('relative h-2 w-full bg-neutral-900 rounded overflow-hidden', className)}>
      <div style={{ width: `${filledPercentage}%` }} className={twMerge('absolute h-full', fillColor)} />
    </div>
  );
};
